var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDeliver(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#F87000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.153 18.5565C23.203 18.6595 23.237 18.7705 23.253 18.8845L23.531 23.0245L23.669 25.1055C23.67 25.3195 23.704 25.5325 23.769 25.7365C23.936 26.1335 24.337 26.3855 24.774 26.3675L31.431 25.9325C31.72 25.9275 31.998 26.0355 32.205 26.2325C32.378 26.3955 32.489 26.6105 32.525 26.8405L32.536 26.9805C32.261 30.7955 29.459 33.9775 25.652 34.7985C21.846 35.6195 17.942 33.8845 16.061 30.5355C15.5193 29.5651 15.1801 28.4949 15.064 27.3895C15.016 27.0632 14.995 26.7334 15.001 26.4035C14.995 22.3135 17.907 18.7775 21.984 17.9255C22.475 17.8485 22.956 18.1085 23.153 18.5555V18.5565Z",
    fill: "#F87000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M25.8702 15.0008C30.4302 15.1178 34.2622 18.3968 35.0002 22.8128L34.9932 22.8458L34.9732 22.8928L34.9762 23.0228C34.9654 23.1969 34.898 23.3626 34.7842 23.4948C34.6647 23.6343 34.5022 23.73 34.3222 23.7668L34.2122 23.7818L26.5322 24.2798C26.4062 24.2924 26.2789 24.2787 26.1585 24.2396C26.038 24.2006 25.9269 24.137 25.8322 24.0528C25.6752 23.9138 25.5728 23.7235 25.5432 23.5158L25.0282 15.8458C25.0192 15.8199 25.0192 15.7917 25.0282 15.7658C25.0319 15.6608 25.0566 15.5575 25.1009 15.4622C25.1452 15.3668 25.2082 15.2814 25.2862 15.2108C25.4456 15.0666 25.6555 14.9911 25.8702 15.0008Z",
    fill: "#F87000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeliver);
export default __webpack_public_path__ + "static/media/icon-deliver.cdbb7b5a0aceb68c9f8c8b8084258b17.svg";
export { ForwardRef as ReactComponent };